import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth
export const registerUser = (data) => api.post('/auth/register', data);
export const loginUser = (data) => api.post('/auth/login', data);
export const exchangeSession = (sessionId) => api.post('/auth/session', { session_id: sessionId });
export const getMe = () => api.get('/auth/me');
export const logoutUser = () => api.post('/auth/logout');

// Templates
export const getTemplates = () => api.get('/templates');
export const getTemplate = (id) => api.get(`/templates/${id}`);

// Sites
export const createSite = (data) => api.post('/sites/create', data);
export const getMySite = () => api.get('/sites/my-site');
export const updateSite = (data) => api.put('/sites/update', data);
export const getAnalytics = () => api.get('/sites/analytics');
export const previewSiteHtml = (data) => api.post('/sites/preview-html', data, { responseType: 'text' });
export const getSiteHtml = (siteId) => api.get(`/sites/${siteId}/html`, { responseType: 'text' });

// Payment (mocked)
export const mockCheckout = () => api.post('/payment/mock-checkout');

export default api;
